"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const galleryItems = [{
  id: 1,
  title: "Luxury Suite",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1684351/img/luxury_suite_transformation.png",
  alt: "AI-enhanced luxury hotel suite with warm lighting"
}, {
  id: 2,
  title: "Alpine Cabin",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1684351/img/alpine_cabin_interior.png",
  alt: "Cozy alpine cabin interior with enhanced textures"
}, {
  id: 3,
  title: "Boutique Lobby",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1684351/img/boutique_hotel_lobby.png",
  alt: "Modern boutique hotel lobby with premium AI editing"
}, {
  id: 4,
  title: "Ocean View",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1684351/img/ocean_view_apartment.png",
  alt: "Apartment with ocean view and optimized color balance"
}, {
  id: 5,
  title: "Penthouse Terrace",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1684351/img/penthouse_terrace_night.png",
  alt: "Penthouse terrace at night with professional AI lighting"
}, {
  id: 6,
  title: "Modern Kitchen",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1684351/img/airbnb_kitchen_refresh.png",
  alt: "Airbnb kitchen with crisp, clean AI-enhanced details"
}, {
  id: 7,
  title: "Master Bedroom",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1684351/img/master_bedroom_elegance.png",
  alt: "Elegant master bedroom with soft gold accents"
}];
export default function VisualTransformationGallery() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="226209" id="visual-transformation-gallery" className="bg-background text-foreground py-24 px-4 md:px-8 overflow-hidden">
      <div ref={ref} className={`max-w-7xl mx-auto transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
        <div className="text-center mb-16">
          <h2 className="font-default text-4xl md:text-5xl lg:text-6xl font-light tracking-wider mb-4 text-primary">
            Visual Transformation Gallery
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto text-lg font-sans font-normal leading-relaxed">
            Experience the power of AI-enhanced photography. Hover over our curated property transformations to see the Better Hotel Photos difference.
          </p>
        </div>

        {}
        <div className="columns-1 sm:columns-2 lg:columns-3 gap-2 space-y-2">
          {galleryItems.map((item, i) => <div key={item.id} data-index={i} className="group relative overflow-hidden break-inside-avoid rounded-md cursor-pointer bg-muted border border-border">
              <img src={item.src} alt={item.alt} className="w-full h-auto object-cover transition-transform duration-1000 ease-in-out group-hover:scale-105" loading="lazy" />
              
              {}
              <div className="absolute inset-0 bg-background/80 opacity-0 group-hover:opacity-100 transition-opacity duration-700 flex items-center justify-center backdrop-blur-sm">
                <div className="text-center px-6">
                  <span className="block text-xs uppercase tracking-[0.2em] text-secondary font-semibold mb-2 translate-y-4 group-hover:translate-y-0 transition-transform duration-500">
                    Before & After
                  </span>
                  <span className="font-default text-foreground text-2xl md:text-3xl font-light tracking-wide translate-y-4 group-hover:translate-y-0 transition-transform duration-700 delay-75">
                    {item.title}
                  </span>
                </div>
              </div>

              {}
              <div className="absolute top-4 right-4 bg-secondary/90 text-secondary-foreground px-3 py-1 text-[10px] uppercase tracking-widest font-bold rounded-sm shadow-sm">
                {item.title}
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}